import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, ProgressBar } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import { revelarReset } from '../../../redux/actions/index'
import {
  alertaAtencao,
  elipseVerde,
  exclamacao,
  fecharJanela,
  lixeiraVermelho
} from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarData } from '../../../utils/formatadorDataTabela'
import { identificarValidacaoAcoes } from '../../../utils/identificarValidacaoAcoes'
import PaginacaoTabela from '../../../utils/paginacaoTabela'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'

const valorLimite = 50
let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let simcardSelecionados = []
let itensVar = []

const routeM1FiltrarSimcard = '/m1/filtrar/simcard'

export default function Manutencao(props) {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const { register, handleSubmit, errors } = useForm()
  const [dsMotivo, setDsMotivo] = useState('')
  const [caracteresMensagem, setCaracteresMensagem] = useState(1000)
  const [renderizar, setRenderizar] = useState(false)
  const [quantidadeLinhasSelecionados, setQuantidadeLinhasSelecionados] =
    useState(-1)
  const [linhaRemover, setLinhaRemover] = useState('')
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [simcards, setSimcards] = useState([])
  const [linhas, setLinhas] = useState([])
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [tituloMensagemAlerta, setTituloMensagemAlerta] = useState('')
  const [revelarMensagemAtencaoInvalido, setRevelarMensagemAtencaoInvalido] =
    useState(false)
  const [
    revelarMensagemAtencaoLimiteSimcards,
    setRevelarMensagemAtencaoLimiteSimcards
  ] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [itens, setItens] = useState([])
  const [itensInvalidos, setItensInvalidos] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [itensInvalidosBusca, setItensInvalidosBusca] = useState(false)

  const despacho = useDispatch()
  const modal = useRef()

  let filtros = useSelector((state) => state.filtrosState.filtros)
  let buscaArquivo = useSelector(
    (state) => state.buscaArquivoState.buscaArquivo
  )
  let modoSelecaoSimcard = useSelector(
    (state) => state.manejadorState.modoSelecaoSimcard
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let separadorLinha = useSelector(
    (state) => state.manejadorState.separadorLinha
  )
  let itensTemp = []
  let itensInvalidosTemp = []

  const iconeAlerta = (
    <img className="icone-alerta" src={exclamacao()} alt="exclamacao" />
  )
  useEffect(() => {
    setSpinAtivo(true)
    async function preencherTabela() {
      const validacao = await identificarValidacaoAcoes(
        props.itensSelecionados,
        4,
        { filtros, buscaArquivo },
        modoSelecaoSimcard,
        conteudoBusca,
        separadorLinha
      )

      if (modoSelecaoSimcard) {
        itensTemp = validacao.itensValidos
        itensInvalidosTemp = validacao.itensInvalidos
        setItensInvalidos(validacao.itensInvalidos)
        if (itensInvalidosTemp.length > 0) {
          await Promise.all(
            validacao.itensInvalidos.map((item_validacao) => {
              simcardSelecionados += item_validacao.CD_SIMCARD + ','
            })
          )
          setItensInvalidosBusca(simcardSelecionados)
          setSimcards(validacao.itensValidos)
        } else {
          handlerConsultarSimcadsBusca()
        }
      } else {
        setItens(validacao.itensValidos)
        setItensInvalidos(validacao.itensInvalidos)
        itensTemp = validacao.itensValidos
        itensInvalidosTemp = validacao.itensInvalidos
        handleIdSimcards()
        setItensInvalidosBusca(true)
      }
      setTituloMensagemAlerta(
        `${!itensTemp.length > 0 ? 'Todas as' : itensInvalidosTemp.length} linhas foram retiradas`
      )

      handleLinhasSelecionadasIncapacitadas()
      setSpinAtivo(false)
    }
    preencherTabela()

    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
  }, [renderizar])

  async function contarItens() {
    let arrayItens = []
    let apiData = []

    if (controladorPagina <= paginaAtual) {
      const urlGet = `${routeM1FiltrarSimcard}?acao=true&buscar=${conteudoBusca}&filtros=${JSON.stringify(filtros)}&buscaArquivo=${JSON.stringify(buscaArquivo)}&separador=${separadorLinha}&contar=true&itensInvalidosBusca=${itensInvalidosBusca}`
      apiData = await api_gateway
        .get(urlGet)
        .then(function (resposta) {
          return resposta
        })
        .catch(function (erro) {
          throw erro
        })
    }

    totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
    totalItens = apiData.data.dados[0].CONTADOR
    for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
      arrayItens.push(i)
    }
    itensVar = arrayItens
  }

  const opcoesPaginacao = {
    page: paginaAtual,
    showTotal: true,
    sizePerPage: valorLimite,
    firstPageTitle: 'Primeira',
    lastPageTitle: 'Última',
    nextPageTitle: 'Proxima',
    prePageTitle: 'Anterior',
    custom: true,
    onPageChange: (page) => {
      setPaginaAtual(page)
    }
  }

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  const colunasItensInvalidos = [
    {
      dataField: 'CALLERID',
      text: 'Linha',
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-nao-permitidos">{cell}</p>
      }
    },
    {
      dataField: 'ds_motivo',
      text: 'Motivo',
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-nao-permitidos">{cell}</p>
      }
    }
  ]

  const colunas = [
    {
      dataField: 'CD_SIMCARD',
      text: 'Código',
      headerClasses: 'nao-selecionavel',
      hidden: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'OPERADORA',
      text: 'Operadora',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'CALLERID',
      headerClasses: 'nao-selecionavel',
      text: 'Linha',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'ICCID',
      headerClasses: 'nao-selecionavel',
      text: 'ICCID',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'PLANO',
      headerClasses: 'nao-selecionavel',
      text: 'Plano',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell} MB</p>
      }
    },
    {
      dataField: 'CONSUMO_PERCENTUAL',
      text: 'Consumo (%)',
      headerClasses: 'centralizar nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        let styleProgressBar = ''
        if (!cell || cell == '') cell = 0

        styleProgressBar = '#36D896'

        return (
          <ProgressBar className="barra-progresso-container">
            <ProgressBar
              style={{ backgroundColor: styleProgressBar }}
              now={cell}
            />
            <span className="texto-barra-progresso fonte-cor-1">
              {cell === undefined ? '0.00%' : cell.toFixed(2) + '%'}
            </span>
          </ProgressBar>
        )
      }
    },
    {
      dataField: 'ULTIMO_EVENTO',
      headerClasses: 'nao-selecionavel',
      text: 'Último evento',
      sort: true,
      style: {
        paddingLeft: '0px'
      },
      formatter: (cell) => {
        if (cell) {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return formatarData(cell)
      }
    },
    {
      dataField: 'acoes',
      text: '',
      sort: false,
      headerClasses: 'tabela-coluna-ultima-header nao-selecionavel',
      formatter: () => {
        return (
          <Button
            variant="danger"
            className="botoes-tabela-acoes"
            size="sm"
            onClick={() => handleMensagemAtencao(false)}
          >
            <img
              className="icone-botao-acao-tabela"
              src={lixeiraVermelho()}
              alt="remover-linha"
            />
          </Button>
        )
      }
    }
  ]

  const eventosLinhas = {
    onClick: (e, row) => {
      setLinhaRemover(row.CD_SIMCARD)
    }
  }

  function handleMotivo(motivo) {
    setDsMotivo(motivo)
    setCaracteresMensagem(1000 - motivo.length)
  }

  function handleLinhasSelecionadas() {
    setQuantidadeLinhasSelecionados(itensTemp.length)
    if (itensTemp.length === 0) {
      handleCancelar()
    }
  }

  function handleLinhasSelecionadasIncapacitadas() {
    setQuantidadeLinhasSelecionados(itensTemp.length)

    if (itensInvalidosTemp[0]?.CD_SIMCARD === 'Todos Selecionados') {
      setRevelarMensagemAtencaoLimiteSimcards(true)

      return
    }

    if (itensInvalidosTemp.length > 0) {
      setRevelarMensagemAtencaoInvalido(true)
    }
  }

  async function handleRemoverLinha(CD_SIMCARD) {
    setRevelarMensagemAtencao(false)
    if (modoSelecaoSimcard) {
      let simcardNaoSelecionados = itensInvalidosBusca
      if (itensInvalidosBusca) {
        simcardNaoSelecionados = itensInvalidosBusca
      }
      let simcardSelecionados = simcards
      if (
        simcardNaoSelecionados === undefined ||
        simcardNaoSelecionados === null ||
        simcardNaoSelecionados === false
      ) {
        simcardNaoSelecionados = CD_SIMCARD + ','
      } else {
        simcardNaoSelecionados += CD_SIMCARD + ','
      }
      setItensInvalidosBusca(simcardNaoSelecionados)

      for (let i = contador; i < simcardSelecionados.length; i++) {
        if (simcardSelecionados[i] == CD_SIMCARD) {
          simcardSelecionados.splice(i, 1)
        }
      }

      await Promise.all(
        itensVar.map((item_itensVar, i) => {
          if (CD_SIMCARD == item_itensVar.CD_SIMCARD) {
            itensVar.splice(i, 1)
          }
        })
      )
      await contarItens()
      setItens(itensVar)
      setSimcards(simcardSelecionados)
    } else {
      itensTemp = itens
      itens.forEach(function (e, index) {
        if (CD_SIMCARD == e.CD_SIMCARD) {
          itens.splice(index, 1)
        }
      })
      setItens(itensTemp)
      handleIdSimcards()
      handleLinhasSelecionadas()
    }
  }

  async function handleSalvar() {
    setSpinAtivo(true)
    await api_gateway
      .post('/m1/cadastrar/solicitacao', {
        fl_operadora: 0,
        simcards: simcards,
        FULLCALLERID: linhas,
        cd_crm_solicitacao_tipo: 4,
        cd_crm_solicitacao_status: 1,
        ds_crm_solicitacao: dsMotivo,
        dt_inicio: moment().format('YYYY-MM-DD HH:mm:ss'),
        dt_fim: undefined,
        dt_previsao: undefined,
        ds_rota_permissao: 'veye/dispositivos/acoes/solicitarReset'
      })
      .then(function () {
        setSpinAtivo(false)
        handleMensagemSucesso(false)
      })
      .catch(function () {
        setSpinAtivo(false)
        handleMensagemErro(false)
      })
  }

  async function handleCancelar() {
    contador = 0
    controladorPagina = 1
    totalPaginas = 0
    totalItens = 0
    itensVar = []
    itensInvalidosTemp = []
    simcardSelecionados = []
    despacho(revelarReset(false))
  }

  function inserirData(data) {
    if (itensTemp.length === 0) return

    if (itensVar.length == totalItens) {
      for (let i = 0; i < totalItens; i++) {
        if (contador === i) {
          let k = i
          for (let j = 0; j < data.length; j++) {
            itensVar[k] = data[j]
            k++
          }
        }
        if (i == totalItens - 1) {
          itensTemp = JSON.parse(JSON.stringify(itensVar))
          setItens(JSON.parse(JSON.stringify(itensVar)))
          handleIdSimcards()
        }
      }
      handleLinhasSelecionadas()
    }
  }

  function handleIdSimcards() {
    let tempSimcards = []
    let tempLinhas = []
    for (let i = 0; i < itensTemp.length; i++) {
      tempSimcards.push(itensTemp[i].CD_SIMCARD)
      tempLinhas.push(itensTemp[i].FULLCALLERID)
    }
    simcardSelecionados = tempSimcards
    setLinhas(tempLinhas)
    setSimcards(tempSimcards)
  }

  async function handlerConsultarSimcadsBusca() {
    if (totalPaginas == 0) {
      contador = 0
      itensVar = []
      setItens([])
      await contarItens()
    } else {
      contador = (paginaAtual - 1) * valorLimite
    }
    if (controladorPagina <= paginaAtual) {
      setSpinAtivo(true)

      const urlGet = `${routeM1FiltrarSimcard}?paguinaAtual=${contador}&carregarLimit=${valorLimite}&acao=true&buscar=${conteudoBusca}&ordenador=${props.ordenador}&filtros=${JSON.stringify(filtros)}&buscaArquivo=${JSON.stringify(buscaArquivo)}&separador=${separadorLinha}&contar=false&cd_pav_usuario=${decryptJWT('codigo')}&itensInvalidosBusca=${itensInvalidosBusca}`
      const consultaSimcards = await api_gateway
        .get(urlGet)
        .then(function (resposta) {
          return resposta.data.dados
        })
        .catch(function (erro) {
          throw erro
        })

      setSpinAtivo(false)
      inserirData(consultaSimcards)
    }
  }

  useEffect(() => {
    if (modoSelecaoSimcard && itensInvalidosBusca) {
      handlerConsultarSimcadsBusca()
    }
  }, [itensInvalidosBusca, paginaAtual])

  function handleMensagemAtencao(confirmacao) {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
      if (confirmacao === true) {
        handleRemoverLinha(linhaRemover)
      }
    }
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      handleCancelar()
    }
    if (confirmacao) {
      props.setRenderizar(!props.renderizar)
    }
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleFecharMensagemItensInvalidos() {
    setRevelarMensagemAtencaoInvalido(!revelarMensagemAtencaoInvalido)
    if (modoSelecaoSimcard) {
      const naoTemItensValidos = itensTemp === 0
      if (naoTemItensValidos || !itens.length <= 0 || itens <= 0) {
        handleCancelar()
      }
    } else {
      if (quantidadeLinhasSelecionados <= 0) {
        handleCancelar()
      }
    }
  }

  return (
    <Form ref={modal} onSubmit={handleSubmit(() => handleSalvar())}>
      <div className="modal-acao-reset fundo-cor-6">
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela nao-selecionavel"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Reset</div>
            </Form.Label>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="container-tabela-modal">
              <PaginationProvider pagination={Paginador(opcoesPaginacao)}>
                {({ paginationProps, paginationTableProps }) => (
                  <>
                    <BootstrapTable
                      classes="tabela-transparente-modais"
                      condensed
                      keyField="id"
                      data={itens}
                      columns={colunas}
                      rowEvents={eventosLinhas}
                      noDataIndication={!spinAtivo && 'Nenhum item encontrado'}
                      bootstrap4
                      {...paginationTableProps}
                    />
                    {modoSelecaoSimcard && (
                      <div className="paguinacao-tabela-modal">
                        <PaginacaoTabela
                          extrato
                          setPaginaAtual={setPaginaAtual}
                          totalPaginas={totalPaginas}
                          totalItens={totalItens}
                          valorLimite={valorLimite}
                          paginaAtual={paginaAtual}
                          page={paginationProps.page}
                          onPageChange={paginationProps.onPageChange}
                        />
                      </div>
                    )}
                  </>
                )}
              </PaginationProvider>
            </div>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <span className="fonte-cor-1 label-normal contador-linhas-acoes-dispositivos">
              {quantidadeLinhasSelecionados} linhas selecionadas
            </span>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group>
              <Form.Label>
                <div className="fonte-cor-1 label-campo">Motivo</div>
              </Form.Label>
              <Form.Control
                className="campo-texto-cor-3 campo-texto-area"
                name="motivo_reset"
                ref={register({ required: true })}
                as="textarea"
                rows="3"
                maxlength="1000"
                placeholder="Descreva aqui o motivo"
                onChange={(e) => handleMotivo(e.target.value)}
              />
              {errors.motivo_reset && (
                <p className="fonte-cor-3 label-alerta">
                  {iconeAlerta} Informe o motivo.
                </p>
              )}
              <Form.Label className="contador-carateres-restantes">
                <div className="fonte-cor-1 label-normal">
                  {caracteresMensagem} caracteres restantes
                </div>
              </Form.Label>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Button
              type="submit"
              className="botao-confirmar"
              variant="success"
              size="sm"
            >
              <div className="fonte-cor-4">Confirmar</div>
            </Button>
            <Button
              className="botao-cancelar"
              variant="success"
              size="sm"
              onClick={() => handleCancelar()}
            >
              <div className="fonte-cor-2">Cancelar</div>
            </Button>
          </Col>
        </Form.Row>
      </div>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="Sua solicitação foi enviada."
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencao && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              handleMensagemAtencao={handleMensagemAtencao}
              mensagemTitulo="Remover linha?"
              mensagemBotao="Remover"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencaoLimiteSimcards && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              handleMensagemAtencao={handleCancelar}
              mensagemTitulo="Atenção"
              mensagemParagrafo1="Todas as linhas foram removidas. A quantidade de SIM cards deve ser entre 1 e 50."
              mensagemBotao="Fechar"
              semBotaoCancelar
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencaoInvalido && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <div className="modal-mensagem-atencao-acoes-simcards fundo-cor-6">
              <div className="mensagem-container-icone">
                <img
                  className="mensagem-icone"
                  src={alertaAtencao()}
                  alt="sucesso"
                />
              </div>
              <div className="fonte-cor-1 label-janela">
                {tituloMensagemAlerta}
              </div>
              <div className="container-tabela-modal-itens-nao-permitidos">
                <BootstrapTable
                  classes="tabela-transparente-modais"
                  keyField="ds_linha"
                  condensed
                  data={itensInvalidos}
                  columns={colunasItensInvalidos}
                  noDataIndication={!spinAtivo && 'Nenhum item encontrado'}
                  bootstrap4
                />
              </div>
              <div className="mensagem-container-botao">
                <Button
                  className="mensagem-botao-cancelar"
                  variant="success"
                  size="sm"
                  onClick={() => handleFecharMensagemItensInvalidos()}
                >
                  <div className="fonte-cor-2">Cancelar</div>
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Form>
  )
}
